import { inject, Injectable } from '@angular/core';
import { UserService } from '../data-service/user.service';
import { StateService } from './state.service';
import {
  INITIAL_USER_STATE,
  UserState
} from 'src/app/models/user-state.interface';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserStateService extends StateService<UserState> {
  private readonly userService = inject(UserService);

  userInfo$ = this.select((state) => state.userInfo);
  canEditPlantationTableColumns$ = this.select(
    (state) => state.canEditPlantationTableColumns
  );
  isDataAdmin$ = this.select(
    (state) => state.userInfo?.is_company_admin ?? false
  );
  userInfoLoaded$ = this.select((state) => state.userInfoLoaded);

  /** Stable per-user key. `id` is optional, so fall back to the email. */
  get currentUserKey(): string | null {
    const userInfo = this.currentState.userInfo;
    return userInfo?.id?.toString() ?? userInfo?.contact?.email ?? null;
  }

  get currentCompanyId(): number | undefined {
    return this.currentState.userInfo?.company?.id;
  }

  constructor() {
    super(INITIAL_USER_STATE);
  }

  getUserInfo() {
    this.userService
      .getUserInfo()
      .pipe(take(1))
      .subscribe({
        next: (userInfo) => {
          const isDataAdmin = userInfo.is_company_admin;
          this.setState({
            userInfo,
            canEditPlantationTableColumns: isDataAdmin,
            userInfoLoaded: true
          });
        },
        error: () => {
          this.setState({
            userInfo: null,
            canEditPlantationTableColumns: false,
            userInfoLoaded: true
          });
        }
      });
  }
}
